/* Beaux-Arts — Media player
   Loads the selected film into the sticky stage on the left.
   No autoplay until someone clicks, so nothing loads on page view. */

class BeauxMedia extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-ba-stage]');
    this.poster = this.querySelector('[data-ba-poster]');
    this.name = this.querySelector('[data-ba-name]');
    this.nameKo = this.querySelector('[data-ba-name-ko]');
    this.desc = this.querySelector('[data-ba-desc]');
    this.thumbs = Array.from(this.querySelectorAll('[data-ba-thumb]'));

    if (this.poster) {
      this.poster.addEventListener('click', () => {
        this.play(this.poster.dataset.embed, this.poster.querySelector('img'));
      });
    }

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.select(thumb));
    });
  }

  select(thumb) {
    this.thumbs.forEach((t) => t.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');

    if (this.name) this.name.textContent = thumb.dataset.name || '';
    if (this.nameKo) this.nameKo.textContent = thumb.dataset.nameKo || '';
    if (this.desc) this.desc.textContent = thumb.dataset.desc || '';

    this.play(thumb.dataset.embed, thumb.querySelector('img'));

    // On narrow screens the stage sits above the grid — bring it into view.
    if (window.matchMedia('(max-width: 989px)').matches && this.stage) {
      this.stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  play(embed, sourceImage) {
    if (!this.stage) return;

    if (!embed) {
      // No video attached: show the still on its own.
      this.stage.innerHTML = '';
      if (sourceImage) this.stage.appendChild(sourceImage.cloneNode(true));
      return;
    }

    const frame = document.createElement('iframe');
    frame.setAttribute('src', embed);
    frame.setAttribute('title', (this.name && this.name.textContent) || 'Film');
    frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    frame.setAttribute('allowfullscreen', 'true');
    frame.setAttribute('loading', 'lazy');

    this.stage.innerHTML = '';
    this.stage.appendChild(frame);
  }
}

if (!customElements.get('beaux-media')) {
  customElements.define('beaux-media', BeauxMedia);
}
